import {LiveChecksStatusBadge} from '@github-ui/commit-checks-status/LiveChecksStatusBadge'
import {useCurrentRepository} from '@github-ui/current-repository'
import {isFeatureEnabled} from '@github-ui/feature-flags'

interface Props {
  oid: string
  status: string | undefined
  aliveChannel?: string | null
}

export function ReposChecksStatusBadge({status, oid, aliveChannel}: Props) {
  const repo = useCurrentRepository()
  const liveUpdatesEnabled = isFeatureEnabled('code_view_checks_live_updates')

  return (
    <LiveChecksStatusBadge
      oid={oid}
      statusRollup={status}
      repo={repo}
      aliveChannel={liveUpdatesEnabled ? aliveChannel : undefined}
      size="small"
    />
  )
}
